import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { SUCCESS_NOTIFICATION_EVENT, NotificationTone } from '../../helpers/toast';

// Non-blocking QLYT-style notification shared by successful application actions.
export default function SuccessNotification() {
    const sequence=useRef(0);
    const [notification, setNotification] = useState<{message:string;title:string;id:number;tone?:NotificationTone}|null>(null);
    useEffect(()=>{
        const show=(event:Event)=>{
            const detail=(event as CustomEvent<string|{message:string;title:string;tone?:NotificationTone}>).detail;
            setNotification({...(typeof detail==='string'?{message:detail,title:'Thành công'}:detail),id:++sequence.current});
        };
        window.addEventListener(SUCCESS_NOTIFICATION_EVENT,show);
        return()=>window.removeEventListener(SUCCESS_NOTIFICATION_EVENT,show);
    },[]);
    useEffect(()=>{
        if(!notification)return;
        const timer=window.setTimeout(()=>setNotification(null),5000);
        return()=>window.clearTimeout(timer);
    },[notification]);
    if(!notification)return null;
    const tone=notification.tone ?? 'success';
    const icon={success:'check-lg',error:'x-lg',warning:'exclamation-triangle',info:'info-lg'}[tone];
    return createPortal(<aside className={`app-success-feedback app-feedback-${tone}`} key={notification.id} aria-label={notification.title}>
            <div className="success-feedback-icon" aria-hidden="true"><i className={`bi bi-${icon}`}/></div>
            <div className="success-feedback-content" role={tone==='error'?'alert':'status'} aria-live={tone==='error'?'assertive':'polite'} aria-atomic="true">
                <h2>{notification.title}</h2>
                <p>{notification.message}</p>
            </div>
            <button type="button" className="success-feedback-close" aria-label="Đóng thông báo" onClick={()=>setNotification(null)}><i className="bi bi-x" aria-hidden="true"/></button>
            <div className="success-feedback-timer" aria-hidden="true"><span/></div>
    </aside>,document.body);
}
